import { request } from '@/lib/apiClient';

export const dashboardApi = {
  /** One request backs the whole overview screen. */
  get: () => request({ url: '/admin/dashboard' }),
};
